<script>
    // @ts-nocheck
    import { Form, Button, Row, Select, InputText, InputHidden } from '../UI'
    import Stepper from '../UI/Stepper.svelte'
    import Section from './Section.svelte'
    import Redirect from '../layout/Redirect.svelte'
    import AlertValidacion from '$lib/custom/components/AlertValidacion.svelte'
    import TerminosCondiciones from '$lib/custom/components/TerminosCondiciones.svelte'
    import DatosProveedor from './DatosProveedor.svelte'
    import AcreditacionCuenta from './AcreditacionCuenta.svelte'
    import InformacionLaboral from './InformacionLaboral.svelte'
    import InformacionImpositiva from './InformacionImpositiva.svelte'
    import Sucursales from './Sucursales.svelte'
    import dictionaries from '../../stores/dictionaries'
    import { fade } from 'svelte/transition'
    import { useNavigate } from 'svelte-navigator'
    import { API_URL, ENV } from '$lib/conf'
    const navigate = useNavigate()
    export let data = {}
    // export let valid;
    export let incorrectFields = {}
    export let uuid = null
    let aceptoTerminos = false
    let providerSiniestros = false
    const fetchInvitation = fetch(`${API_URL}/invitation/${uuid}`).then(
        async (r) => {
            if (r.ok) {
                let ret = await r.json()
                console.log(ret)
                providerSiniestros = ret?.siniestros || false
                return ret
            } else {
                throw new Error(
                    'Error al recuperar datos desde Athento. Verifique que la VPN esté conectada.'
                )
            }
        }
    )

    let continueModal = false

    function sendData() {
        const navParams = {
            state: {
                title: '¡Alta Exitosa!',
                desc: 'Su solicitud está siendo procesada.',
                icon: 'claimPositive',
            },
            replace: true,
        }

        fetch(`${API_URL}/provider/${uuid ? uuid : ''}`, {
            method: 'POST',
            body: JSON.stringify(persistentDataForm),
        })
            .then(async (r) => {
                if (r.ok) {
                    aceptoTerminos = true
                    navigate('/result', navParams)
                } else {
                    aceptoTerminos = true
                    throw new Error(
                        'Error al recuperar datos desde Athento. Verifique que la VPN esté conectada.'
                    )
                }
            })
            .catch((_) => {})
        aceptoTerminos = false
    }
    $: sections = [
        { label: 'Sobre la Empresa', component: DatosProveedor },
        {
            label: 'Información Impositiva',
            component: InformacionImpositiva,
            options: { showDoc: true },
        },
        ...(!providerSiniestros
            ? [
                  {
                      label: 'Información Laboral y Previsional',
                      component: InformacionLaboral,
                  },
              ]
            : []),
        ...(providerSiniestros
            ? [
                  {
                      label: 'Sucursales',
                      component: Sucursales,
                      options: { showDoc: true },
                  },
              ]
            : []),
        { label: 'Acreditación de Cuenta', component: AcreditacionCuenta },
    ]
    let persistentDataForm = {}
    let currentSection = 0
    let validForm
    const saveData = (_) => {
        persistentDataForm = { ...persistentDataForm, ...data }
    }
    let rawData = {}
    // $: incorrectFields
    $: incorrectFields_ = {
        ...incorrectFields,
        ...Object.fromEntries(
            Object.entries(rawData).filter(([k, v]) => {
                return (
                    k.match(/^docu_.+$/) != null &&
                    !v.valid &&
                    (v.value instanceof Array
                        ? v.value?.some(
                              (x) => x && Object.values(x).length >= 4
                          )
                        : Object.values(v ? v?.value || {} : {})?.length >= 4)
                )
            })
        ),
    }
    // $: console.log({incorrectFields})
    $: console.log({
        // isValidForm,
        // validForm,
        // lenIncorrectFields: Object.keys(incorrectFields)?.length || null,
        incorrectFields_,
        rawData,
    })
    $: console.log({ persistentDataForm })
    $: isValidForm =
        validForm &&
        Object.keys(incorrectFields_).filter((x) => !['fax_ac'].includes(x))
            .length === 0
</script>

<div out:fade class="formulario">
    <Form bind:data bind:incorrectFields bind:raw={rawData}>
        {#await fetchInvitation}
            Cargando invitacion...
        {:then invitationData}
            <Section title="Contacto interno en {ENV.COMPANY_NAME}">
                <Row>
                    {#key $dictionaries.areas}
                        <Select
                            label="Area"
                            name="area_ci"
                            disabled
                            placeholder="Seleccione una opción."
                            value={invitationData?.area || ''}
                            options={$dictionaries.areas || []}
                        />
                    {/key}
                    <InputText
                        disabled
                        name="nombre_ci"
                        value={invitationData.from || ''}
                        label="Nombre del Contacto"
                    />
                    <InputText
                        disabled
                        name="email_ci"
                        value={invitationData.email || ''}
                        label="Email de contacto"
                    />
                </Row>
                <InputHidden
                    name="ivalua_ep"
                    value={invitationData.fromIvalua ? 'true' : 'false'}
                />
            </Section>
            <hr />
            {#if !['Invitacion Duplicada', 'Datos Ingresados'].includes(invitationData.status)}
                <Stepper breakPoints={sections} bind:current={currentSection} />
                {#key currentSection}
                    <div
                        in:fade={{ duration: 250, delay: 550 }}
                        out:fade={{ duration: 500 }}
                    >
                        <Section title={sections[currentSection]?.label}>
                            <svelte:component
                                this={sections[currentSection]?.component}
                                data={persistentDataForm}
                                {providerSiniestros}
                                bind:valid={validForm}
                                {...sections[currentSection]?.options || {}}
                            />
                        </Section>
                    </div>
                {/key}
            {:else}
                <Redirect
                    path="/result"
                    options={{
                        state: {
                            title: 'Esta invitación ya ha sido usada.',
                            desc: `Esta invitación ya ha sido usada y se encuentra deshabilitada. Por favor contáctate con el usuario que gestionó la invitación.`,
                            icon: 'claimNegative',
                        },
                    }}
                />
            {/if}
        {:catch}
            <Redirect
                path="/result"
                options={{
                    state: {
                        title: 'Ocurrió un error al cargar la invitación',
                        desc: `Ocurrió un error al cargar la invitación. Por favor contáctate con el usuario que gestionó la invitación o intente nuevamente más tarde.`,
                        icon: 'claimNegative',
                    },
                }}
            />
        {/await}
    </Form>
    <br />
    <AlertValidacion incorrectFields={incorrectFields_} />
    <span class="buttonSet">
        {#if currentSection !== 0}
            <Button
                style="align-self: start"
                on:click={(_) => {
                    window.scroll(0, 0)
                    saveData()
                    currentSection -= 1
                }}>Atrás</Button
            >
        {/if}
        {#if currentSection === sections.length - 1}
            <Button
                style="align-self: end"
                disabled={!isValidForm}
                on:click={(_) => {
                    saveData()
                    continueModal = true
                }}>Enviar solicitud</Button
            >
        {:else}
            <Button
                style="align-self: end"
                disabled={!isValidForm}
                on:click={(_) => {
                    window.scroll(0, 0)
                    saveData()
                    currentSection += 1
                }}>Siguiente</Button
            >
        {/if}
    </span>
</div>
<!-- {#if ENV.DEV}
  <span style="width: 100%; padding: 25px">
    <CheckBox label="Mostrar datos del formulario [DEV]" bind:value={showDevTools}/>
  </span>
  {#if showDevTools}
    <textarea disabled class="jsonDebug">{JSON.stringify(persistentDataForm, null, 4)}</textarea>
  {/if}
{/if} -->
<TerminosCondiciones bind:show={continueModal} on:send={sendData} />

<style>
    .formulario {
        /* max-width: 1000px; */
        width: 100%;
        min-height: 100%;
        height: fit-content;
        position: relative;
        background: var(--color-white);
        padding: 25px;
        margin: auto;
    }
    /* .jsonDebug {
    position: fixed;
    top: 72px;
    width: 300px;
    height: 250px;
    background: rgba(0,0,0,0.8);
    color: white;
    border-style: none;
    left: 0;
  } */
    .buttonSet {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    @media only screen and (max-width: 600px) {
        .formulario {
            width: 100%;
        }
    }
</style>
